import { userFieldErrors } from "~/constants/userFieldErrors"
import ICamper from "~/interfaces/ICamper"

export const handleCamperErrors = (
  err: any,
  setError: (field: keyof ICamper, error: { message: string }) => void,
): string[] => {
  let toastMessages: string[] = []

  if (err.errors) {
    Object.entries(err.errors as Record<keyof ICamper, Array<string>>).forEach(([key, messages]) => {
      setError(key as keyof ICamper, { message: messages.join(", ") })

      if (key in userFieldErrors && messages.some((m) => m === "has already been taken")) {
        toastMessages.push(userFieldErrors[key])
      }
    })
  } else {
    toastMessages.push(err.message)
  }

  return toastMessages
}
